module.exports = __webpack_public_path__ + "media/agent_2_shake.aa475810.mp3";